

import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Input, Button, Alert, Card } from "antd";
import { LockOutlined, CheckCircleFilled } from "@ant-design/icons";
import axios from "axios";
import "./ResetPassword.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = sessionStorage.getItem('APP_BASE_PATH')
  const { token: pathToken } = useParams(); // ✅ Get token from URL path

  // ✅ Extract token from query parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token") || pathToken; // ✅ Use token from query or path

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  if (!token) {
    return <h2 className="error-message">Invalid or missing reset token. Please request a new password reset.</h2>;
  }

  // ✅ Password Validation Rules
  const passwordCriteria = [
    { label: "At least 8 characters", check: newPassword.length >= 8 },
    { label: "One uppercase & lowercase letter", check: /[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword) },
    { label: "One number", check: /\d/.test(newPassword) },
    { label: "One special character (@, $, !, %, *, ?, &)", check: /[@$!%*?&]/.test(newPassword) }
  ];

  const isValidPassword = passwordCriteria.every(item => item.check);

  const handleSubmit = async () => {
    setPasswordError(null);
    setSuccessMessage(null);

    if (!newPassword || !confirmPassword) {
      setPasswordError("Please enter and confirm your new password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match.");
      return;
    }

    if (!isValidPassword) {
      setPasswordError("Please meet all password requirements before submitting.");
      return;
    }

    try {
      const response = await axios.post(
        `http://localhost:8080/api/reset-password?token=${token}`, // ✅ Token in URL
        { newPassword, confirmPassword }, // ✅ Send passwords in body
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        setSuccessMessage("Password updated successfully! Redirecting to login...");
        setTimeout(() => navigate(`${basePath}/login`), 2000);
      }
    } catch (error) {
      console.error(error);
      setPasswordError("Failed to reset the password. Please try again.");
    }
  };

  return (
    <div className="reset-password-container">
      <Card className="reset-password-card">
        <h2 className="title">Create a New Password</h2>
        <p className="subtitle">Enter a new password for your account.</p>

        <div className="message-container">
          {successMessage && <Alert message={successMessage} type="success" showIcon />}
          {passwordError && <Alert message={passwordError} type="error" showIcon />}
        </div>

        <Input.Password
          className="password-input"
          size="large"
          placeholder="New password"
          prefix={<LockOutlined />}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        {/* ✅ Live Password Validation */}
        <div className="password-criteria">
          {passwordCriteria.map((item, index) => (
            <p key={index} className={item.check ? "valid" : "pending"}>
              <CheckCircleFilled className={`check-icon ${item.check ? "checked" : ""}`} /> {item.label}
            </p>
          ))}
        </div>

        <Input.Password
          className="password-input"
          size="large"
          placeholder="Confirm new password"
          prefix={<LockOutlined />}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <Button className="submit-button" type="primary" onClick={handleSubmit} disabled={!isValidPassword}>
          Update Password
        </Button>
      </Card>
    </div>
  );
};

export default ResetPassword;


